module.exports = __webpack_public_path__ + "img/banner1.1ebb0bd7.png";